<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 1 - Date Range</label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label style="color: firebrick;">From Date</label>
        <input type="date" [(ngModel)]="selected_from_date" (ngModelChange)="changeEvent()" class="main-border-class">
      </div>
      <div class="col-4">
        <label style="color: firebrick;">To Date</label>
        <input type="date" [(ngModel)]="selected_to_date" (ngModelChange)="changeEvent()" [min]="selected_from_date"
          class="main-border-class">
      </div>
      <div class="col-4">
        <mat-label>Report Type</mat-label>
        <mat-select [(ngModel)]="report_type" (ngModelChange)="reportTypeChanged()" class="main-border-class">
          <mat-option value="Sale">Sale</mat-option>
          <mat-option value="Received">Received</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="col-4" *ngIf="report_type == 'Sale'">
        <mat-label>Report Option</mat-label>
        <mat-select [(ngModel)]="report_option" (ngModelChange)="reportOptionChanged()" class="main-border-class">
          <mat-option value="Booth Wise">Booth Wise</mat-option>
          <mat-option value="Business Type Wise">Business Type Wise</mat-option>
          <mat-option value="Product Wise">Product Wise</mat-option>
        </mat-select>
      </div>
      <div class="col-4" *ngIf="report_type == 'Received'">
        <mat-label>Report Option</mat-label>
        <mat-select [(ngModel)]="report_option" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option value="Total GRN">Total GRN</mat-option>
          <mat-option value="Product Wise">Product Wise</mat-option>
          <mat-option value="Purchase Company">Purchase Company</mat-option>
        </mat-select>
      </div>
      <div class="col-4" *ngIf="report_option == 'Booth Wise'">
        <mat-label>Booth Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="text" [(ngModel)]="booth_codes" class="main-border-class" /><br>
        <label style="color: red;">*Comma seperated booth codes</label>
      </div>
      <div class="col-4" *ngIf="report_option == 'Business Type Wise'">
        <mat-label>Booth Type <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_business_type_list" (ngModelChange)="changeEvent()" class="main-border-class" multiple="true">
          <mat-option [value]="business_type.id" *ngFor="let business_type of business_type_list">{{ business_type.name }}</mat-option>
        </mat-select>
      </div>
      <div class="col-4" *ngIf="report_option == 'Product Wise'">
        <mat-label>Product Group <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_product_group_id" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option [value]="by_product_group.id" *ngFor="let by_product_group of by_product_group_list">{{ by_product_group.name }}</mat-option>
        </mat-select>
      </div>
      <div class="col-4" *ngIf="report_option == 'Product Wise'">
        <mat-label>Product <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_product_ids" (ngModelChange)="changeEvent()" class="main-border-class" multiple="true">
          <mat-option [value]="by_product.id" *ngFor="let by_product of by_product_dict[selected_product_group_id]">{{ by_product.name }}</mat-option>
        </mat-select>
      </div>
      <div class="col-4" *ngIf="report_option == 'Total GRN'">
        <mat-label>GRN Numbers <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="text" style="border: 1px solid;border-radius: 14px;padding: 10px;"
        [(ngModel)]="grn_numbers" (ngModelChange)="changeEvent()" /><br>
        <label style="color: red;">*Comma seperated grn number in capital</label>
      </div>
      <div class="col-4" *ngIf="report_option == 'Purchase Company'">
        <mat-label>Purchase Company <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_purchase_company_list" (ngModelChange)="changeEvent()" class="main-border-class" multiple="true">
          <mat-option [value]="purchase_company.id" *ngFor="let purchase_company of purchase_company_list">{{ purchase_company.company_name }}</mat-option>
        </mat-select>
      </div>
    </div>
    <br>
    <div class="row" style="text-align: center;">
      <div class="col-4" style="text-align: center;">
        <button mat-button class="button-class" (click)="getClicked()">Get</button>
      </div>
      <div class="col-4" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
        </mat-progress-spinner>
      </div>
      <div class="col-4" *ngIf="document_file!== null && is_document_available">
        <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>
    </div>
  </div>
</section>
